import { CounselorOfApplicantMiniProfilePortable } from "@3gaam/api/types/consultancy";
import { Avatar } from "@3gaam/shared/components/general/avatar";
import { animated, useSpring } from "react-spring";
import Icon from "../general/icon";

type Props = {
  counselor: CounselorOfApplicantMiniProfilePortable;
  size: number;
  noBorder?: boolean;
  noOnlineCircle?: boolean;
};

const CounselorAvatar = ({
  counselor,
  size,
  noBorder,
  noOnlineCircle,
}: Props) => {
  let borderWidth = 2;
  let activeBorder =
    counselor.UpcomingAppointment ||
    (counselor.NewMessagesCount && counselor.NewMessagesCount > 0);

  let hasBothAppointmentAndMessage =
    counselor.UpcomingAppointment &&
    counselor.NewMessagesCount &&
    counselor.NewMessagesCount > 0;

  const onlineAnimatedStyles = useSpring({
    from: {
      scale: 1,
    },
    to: [
      {
        scale: 1,
      },
      {
        scale: 1.08,
      },
    ],

    loop: {
      reverse: true,
    },
    config: {
      tension: 150,
      damping: 0,
    },
  });

  const iconsAnimatedStyles = useSpring({
    from: {
      phone: 1,
      message: 0,
    },
    to: [
      {
        phone: 1,
        message: 0,
      },
      {
        phone: 0,
        message: 1,
      },
    ],
    loop: {
      reverse: true,
    },
    config: {
      tension: 150,
      damping: 0,
    },
  });

  return (
    <>
      <div
        className="d-flex align-items-center justify-content-center mt-2 flex-shrink-0"
        style={{
          width: size,
          height: size,
          borderRadius: size,
          backgroundColor: noBorder
            ? undefined
            : activeBorder
            ? "#6e00aa"
            : "#9e9e9e",
          position: "relative",
        }}
      >
        {!noOnlineCircle && !!counselor.Online && (
          <animated.div
            style={{
              position: "absolute",
              width: size + 7,
              height: size + 7,
              borderWidth: 2,
              borderRadius: size + 2,
              borderColor: "#40d8af",
              borderStyle: "solid",
              ...onlineAnimatedStyles,
            }}
          />
        )}
        <Avatar
          size={size - borderWidth * 2}
          src={counselor.Avatar}
          noBorder={true}
          alt={counselor.Name}
        />
        {!!activeBorder && (
          <div
            style={{
              width: 20,
              height: 20,
              borderRadius: 20,
              position: "absolute",
              top: 0,
              left: 0,
              ...(noBorder
                ? {
                    borderWidth: 1,
                    borderStyle: "solid",
                    borderColor: "#fff",
                  }
                : {}),
            }}
            className="bg-primary d-flex align-items-center justify-content-center flex-shrink-0"
          >
            {!!counselor.UpcomingAppointment && (
              <animated.div
                style={{
                  position: "absolute",
                  margin: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  opacity: hasBothAppointmentAndMessage
                    ? iconsAnimatedStyles.phone
                    : 1,
                }}
              >
                <Icon name="FA_R-phone-flip" className="text-white font-18" />
              </animated.div>
            )}
            {!!(
              counselor.NewMessagesCount && counselor.NewMessagesCount > 0
            ) && (
              <animated.div
                style={{
                  position: "absolute",
                  margin: "auto",
                  opacity: hasBothAppointmentAndMessage
                    ? iconsAnimatedStyles.message
                    : 1,
                }}
              >
                <span className="text-white font-12">
                  {counselor.NewMessagesCount}
                </span>
              </animated.div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default CounselorAvatar;
